import Image from 'next/image';
import Link from '@components/mdx/Link';

const MDX = {
  a: Link,
  Image
};

export default MDX;
